/**
 * Shared Urgency Style Utilities
 *
 * Single source of truth for deadline urgency colors, badges, and labels.
 * Used by Calendar.tsx and DeadlinesWidget.tsx.
 */

import type { CalendarDeadline, DeadlineUrgency } from '../services/calendarService';

export function getUrgencyDotClass(urgency: DeadlineUrgency): string {
  switch (urgency) {
    case 'OVERDUE':
    case 'CRITICAL':
      return 'bg-brand-error-500';
    case 'URGENT':
      return 'bg-brand-warning-500';
    default:
      return 'bg-brand-success-500';
  }
}

export function getUrgencyBadgeClasses(urgency: DeadlineUrgency): string {
  switch (urgency) {
    case 'OVERDUE':
    case 'CRITICAL':
      return 'bg-brand-error-100 text-brand-error-700';
    case 'URGENT':
      return 'bg-brand-warning-100 text-brand-warning-700';
    default:
      return 'bg-brand-success-100 text-brand-success-700';
  }
}

export function getUrgencyLabel(deadline: CalendarDeadline): string {
  if (deadline.daysRemaining < 0) return 'OVERDUE';
  if (deadline.daysRemaining === 0) return 'DUE TODAY';
  return `${deadline.daysRemaining}d`;
}
